import { privateGet } from "../clients/createPrivateClient";
import {
  AddressSearchProvider,
  GeocodeAddressResult,
  SearchAddressResult,
} from "../models/mainservice";
import { CPCodebooksResult, CPCompanyInfoResult } from "../models/unified";

export default {
  getCompanyAndCustomerInfo: async () => {
    const result = await privateGet<CPCompanyInfoResult>(
      `customerPortal/company/v2/info`,
    );

    return result;
  },
  getCodebooks: async () => {
    const result = await privateGet<CPCodebooksResult>(
      `customerPortal/company/v2/codebooks`,
    );

    return result;
  },
  searchForAddresses: async (
    searchPhrase: string,
    provider: AddressSearchProvider,
  ) => {
    const result = await privateGet<SearchAddressResult>(
      `address/search/v2/${searchPhrase}`,
      { provider },
    );

    return result;
  },
  geocodePlaceId: (placeId: string, provider: AddressSearchProvider) => {
    return privateGet<GeocodeAddressResult>(
      `address/geocodePlace/v2/${placeId}`,
      {
        provider,
      },
    );
  },
};
